<template>
	<v-card class="mb-4">
		<v-toolbar flat dense cad>
			<v-toolbar-title class="subheading">Send us your feedback!</v-toolbar-title>
			<v-spacer></v-spacer>
		</v-toolbar>
		<v-divider></v-divider>
		<v-card-text class="">
			<v-subheader style="margin-top:10px;" class="text-xs-left"
				>We're constantly looking at ways to improve our product for you guys and make your experience better. We pride ourselves on being innovators who react quickly to our customers ever changing needs, therefore frequent updates are built
				into our DNA. Send us over any suggestions you have, and we'll do our best to make it happen!</v-subheader
			>

			<v-select
				v-model="form.feedbackType"
				style="margin-top:20px;"
				:items="feedbackTypeOptions"
				:error-messages="feedbackTypeErrors"
				item-text="text"
				label="Feedback Type"
				required
				@change="$v.form.feedbackType.$touch()"
				@blur="$v.form.feedbackType.$touch()"
			></v-select>

			<v-textarea v-model="form.text" :error-messages="textErrors" required box label="Feedback" @input="$v.form.text.$touch()" @blur="$v.form.text.$touch()"></v-textarea>

			<v-alert :value="isSent" type="success">
				Thanks! Your feedback has been sent to our team
			</v-alert>
		</v-card-text>

		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn class="primary" :loading="isSending" @click="sendFeedback"> <v-icon left>send</v-icon>Send Feedback </v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';
	import { mapGetters } from 'vuex';

	export default {
		data() {
			return {
				form: {
					feedbackType: null,
					text: ''
				},
				feedbackTypeOptions: [
					{ text: 'General Feedback', value: 0 },
					{ text: 'Feature Request', value: 1 },
					{ text: 'Bug Report', value: 2 }
				],
				isSending: false,
				isSent: false
			};
		},
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee',
				loggedInTenant: 'loggedInTenant'
			}),
			textErrors() {
				const errors = [];
				if (!this.$v.form.text.$dirty) return errors;
				!this.$v.form.text.required && errors.push('Feedback is required.');
				return errors;
			},
			feedbackTypeErrors() {
				const errors = [];
				if (!this.$v.form.feedbackType.$dirty) return errors;
				!this.$v.form.feedbackType.required && errors.push('Feedback Type is required.');
				return errors;
			}
		},
		methods: {
			sendFeedback() {
				this.$v.form.$touch();

				if (this.$v.form.$invalid) {
					console.log('invalid form');
				} else {
					let postObj = {
						tenantName: this.loggedInTenant.name,
						employeeName: this.loggedInEmployee.fullName,
						employeeId: this.loggedInEmployee.id,
						employeeEmail: this.loggedInEmployee.email,
						feedbackType: this.form.feedbackType,
						text: this.form.text
					};
					this.isSending = true;
					this.$store.dispatch('sendAppFeedback', postObj).then(
						response => {
							this.isSending = false;
							this.isSent = true;
							this.clear();
						},
						error => {
							this.isSending = false;
						}
					);
				}
			},
			clear() {
				this.$v.form.$reset();
				this.form = {
					feedbackType: null,
					text: ''
				};
			}
		},
		mixins: [validationMixin],

		validations: {
			form: {
				text: { required },
				feedbackType: { required }
			}
		}
	};
</script>

<style></style>
